export const cells = [
   {
      id: 1,
      title: 'A1',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 2,
      title: 'A2',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 3,
      title: 'A3',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 4,
      title: 'A4',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 5,
      title: 'A5',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 6,
      title: 'A6',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 7,
      title: 'B1',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 8,
      title: 'B2',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 9,
      title: 'B3',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 10,
      title: 'B4',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 11,
      title: 'B5',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 12,
      title: 'B6',
      width: '48px',
      height: '48px',
      color: 'grey'
   }, {
      id: 13,
      title: 'C1',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 14,
      title: 'C2',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 15,
      title: 'C3',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 16,
      title: 'C4',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 17,
      title: 'C5',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 18,
      title: 'C6',
      width: '48px',
      height: '48px',
      color: 'grey'
   }, {
      id: 19,
      title: 'D1',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 20,
      title: 'D2',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 21,
      title: 'D3',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 22,
      title: 'D4',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 23,
      title: 'D5',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 24,
      title: 'D6',
      width: '48px',
      height: '48px',
      color: 'grey'
   }, {
      id: 25,
      title: 'E1',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 26,
      title: 'E2',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 27,
      title: 'E3',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 28,
      title: 'E4',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 29,
      title: 'E5',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 30,
      title: 'E6',
      width: '48px',
      height: '48px',
      color: 'grey'
   },{
      id: 31,
      title: 'F1',
      width: '100px',
      height: '48px',
      color: 'grey'
   },{
      id: 32,
      title: 'F2',
      width: '100px',
      height: '48px',
      color: 'grey'
   },{
      id: 33,
      title: 'F3',
      width: '100px',
      height: '48px',
      color: 'grey'
   },{
      id: 34,
      title: 'G1',
      width: '100px',
      height: '48px',
      color: 'grey'
   },{
      id: 35,
      title: 'G2',
      width: '100px',
      height: '48px',
      color: 'grey'
   },{
      id: 36,
      title: 'G3',
      width: '100px',
      height: '48px',
      color: 'grey'
   },{
      id: 37,
      title: 'H1',
      width: '100px',
      height: '48px',
      color: 'grey'
   },{
      id: 38,
      title: 'H2',
      width: '100px',
      height: '48px',
      color: 'grey'
   },{
      id: 39,
      title: 'H3',
      width: '100px',
      height: '48px',
      color: 'grey'
   },{
      id: 40,
      title: 'I1',
      width: '100px',
      height: '48px',
      color: 'grey'
   },{
      id: 41,
      title: 'I2',
      width: '100px',
      height: '48px',
      color: 'grey'
   },{
      id: 42,
      title: 'I3',
      width: '100px',
      height: '48px',
      color: 'grey'
   }
   ,{
      id: 43,
      title: 'J1',
      width: '100px',
      height: '100px',
      color: 'grey'
   },{
      id: 44,
      title: 'J2',
      width: '100px',
      height: '100px',
      color: 'grey'
   },{
      id: 45,
      title: 'J3',
      width: '100px',
      height: '100px',
      color: 'grey'
   },{
      id: 46,
      title: 'K1',
      width: '100px',
      height: '100px',
      color: 'grey'
   },{
      id: 47,
      title: 'K2',
      width: '100px',
      height: '100px',
      color: 'grey'
   },{
      id: 48,
      title: 'K3',
      width: '100px',
      height: '100px',
      color: 'grey'
   }
]